module.exports = __webpack_public_path__ + "img/logo-150x150.3bc0535b.png";